// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"F_-z","narrowOptionButtons":"G_-z","noOptions":"H_-z"};